module.exports = __webpack_public_path__ + "img/export-dialogue-icon.eb5d1345.svg";